export default __webpack_public_path__ + "static/media/KOD0090-min.1d09c488.webp";